import React, { Component, PropTypes } from 'react'
import CSSModules from 'react-css-modules'
import config from '../../config'
import {
  Link,
} from '../../components'
import Styles from './FundEngagementGradeBox.css'


@CSSModules(Styles)
export default class FundEngagementGradeBox extends Component {
  static propTypes = {
    issueId: PropTypes.string.isRequired,
  }
  constructor(props){
    super(props)

    const issueLabelCap = {
      ERR: '',
      gef: 'Gender Equality',
      dei: 'Diversity Disclosures',
      rji: 'Racial Justice',
      hrc: 'LGBTQ+ equity',
    }[this.props.issueId || 'ERR']

    const issueLabel = {
      ERR: '',
      gef: 'gender equality',
      dei: 'diversity disclosures',
      rji: 'racial justice',
      hrc: 'LGBTQ+ equity',
    }[this.props.issueId || 'ERR']

    this.state = {
      issueLabelCap,
      issueLabel,
    }
  }
  //
  render() {
    const eGradeShield = require( '../../../static/images/icn-engagement-shield.svg' )
    //
    return <div styleName='fund-e-grade-box'>
      <img
        src={eGradeShield}
        alt='Engagement grade'
        styleName='fund-e-grade-box__icon'
      />
      <h3 styleName='fund-e-grade-box__title'>
        Engagement Grade: {this.state.issueLabelCap}
      </h3>
      <p styleName='fund-e-grade-box__copy'>
        This fund earns an engagement grade for {this.state.issueLabel}. This means the fund is recognized as a leader in advancing equity and justice through active shareholder engagement, community and stakeholder engagement, and fostering impact. 
        The fund’s managers use their influence as investors to press portfolio companies to strengthen workplace equity, disclose meaningful diversity data, and adopt policies that promote inclusion.
        In addition to direct dialogue and proxy voting, the fund integrates these social justice considerations into its investment process — avoiding or divesting from companies that consistently lag on DEI performance or fail to respond to investor concerns.
      </p>
    </div>
  }
}
